import { HttpContextToken } from '@angular/common/http';

export enum HttpMethods {
  GET = 'GET',
  POST = 'POST',
  PUT = 'PUT',
  PATCH = 'PATCH',
  DELETE = 'DELETE',
  HEAD = 'HEAD',
}

export const CUSTOM_CONTEXT = {
  SKIP_AUTH_INTERCEPTOR: new HttpContextToken(() => false),
};
